import _isEmpty from 'lodash/isEmpty';
import _includes from 'lodash/includes';
import _some from 'lodash/some';
import _toLower from 'lodash/toLower';
import _findIndex from 'lodash/findIndex';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import { SelectOption } from '@minecraft.typings';
import { NavigationSection, FilterValues } from '../types';

type GetUpdatedNavigationSectionsArgs = {
  categoryValue: string;
  navigationSections: NavigationSection[];
  filtersOptions: FilterValues;
};

export const getNestedEntity = (entity: SelectOption[]): SelectOption[] => {
  return _reduce(
    entity,
    (acc, item) => {
      return [...acc, ...(item?.options || [])];
    },
    []
  );
};

export const getUpdatedNavigationSections = ({
  categoryValue,
  navigationSections,
  filtersOptions,
}: GetUpdatedNavigationSectionsArgs): NavigationSection[] | null => {
  if (_isEmpty(navigationSections) || _isEmpty(filtersOptions)) return null;

  const newNavigationSections = [...navigationSections];
  const sectionIndex = _findIndex(newNavigationSections, (navigationSection) =>
    _some(navigationSection.options, { value: categoryValue })
  );
  const categoryIndex = _findIndex(newNavigationSections?.[sectionIndex]?.options, {
    value: categoryValue,
  });

  const categoryFiltersWithOptions = _map(
    newNavigationSections?.[sectionIndex]?.options?.[categoryIndex]?.options,
    (filter) => ({
      ...filter,
      ...(filtersOptions[filter.value] && { options: filtersOptions[filter.value] }),
    })
  );

  if (!_isEmpty(categoryFiltersWithOptions)) {
    newNavigationSections[sectionIndex].options[categoryIndex].options = categoryFiltersWithOptions;

    return newNavigationSections;
  }

  return null;
};

export const searchFilterNameOrCategory = (
  searchValue: string,
  navigationSections: NavigationSection[]
): NavigationSection[] => {
  return _reduce(
    navigationSections,
    (acc, option) => {
      const isOptionMatchedSearch = _includes(_toLower(option.label), _toLower(searchValue));

      if (_isEmpty(option?.options) && isOptionMatchedSearch) {
        return [...acc, option];
      }

      if (!_isEmpty(option?.options)) {
        const nestedOptions = searchFilterNameOrCategory(searchValue, option.options);

        return [
          ...acc,
          ...(nestedOptions?.length > 0
            ? [{ ...option, options: nestedOptions }]
            : [...(isOptionMatchedSearch ? [option] : [])]),
        ];
      }

      return acc;
    },
    []
  );
};
